import 'rxjs/add/operator/toPromise';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from './../../environments/environment';
import { UsuarioService } from '../shared/services/usuario.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  oauthUrl: string;
  tokensRevokeUrl: string;
  jwtPayload: any;
  REDIRECT_URI: string;
  REDIRECT_URI_LOGOUT: string;


  constructor(
    private http: HttpClient,
    private jwt: JwtHelperService,
    private user: UsuarioService


  ) {
    this.oauthUrl = `${environment.hosts.bipo_backend_rest}/auth`;
    this.tokensRevokeUrl = `${environment.hosts.bipo_backend_rest}/auth/tokens/revoke`;
    this.REDIRECT_URI = window.location.origin + "/callback";
    this.REDIRECT_URI_LOGOUT = window.location.origin + "/";

    this.carregarToken();
  }



  logout() {
    return this.http.get(this.oauthUrl + "/logout" + "?redirect_uri=" + this.REDIRECT_URI_LOGOUT, { responseType: 'text' })
      .toPromise()
      .then(response => {
        this.limparAccessToken();
        return response;
      });
  }

  login(){   
    return this.http.get(this.oauthUrl + "/authorization-url" + "?redirect_uri=" + this.REDIRECT_URI, { responseType: 'text' })
      .toPromise()
      .then(response => {
        return response;
      });
  }

  loginCallback(authcode) {
    return this.http.post(this.oauthUrl + "/callback?redirect_uri=" + this.REDIRECT_URI.split('?')[0] + "&code=" + authcode, { responseType: 'token' })
      .toPromise()
      .then(response => {
        this.armazenarToken(response['access_token']);
        return response;
      });
  }

  obterNovoAccessToken(): Promise<void> {

    //limpando token antigo
    this.limparAccessToken();
    
    const headers = new HttpHeaders()
    .append('Content-Type', 'application/x-www-form-urlencoded')
    .append('Authorization', 'Basic YW5ndWxhcjpAbmd1bEByMA==');

    const body = 'grant_type=refresh_token';

    return this.http.post(this.oauthUrl, body,
        { headers, withCredentials: true })
      .toPromise()
      .then(response => {
        this.armazenarToken(response['access_token']);


        return Promise.resolve(null);
      })
      .catch(response => {
        return Promise.resolve(null);
      });
  }

  private armazenarToken(token: string){
    this.jwtPayload = this.jwt.decodeToken(token);
    localStorage.removeItem('token'); 
    localStorage.setItem('token', token);
  }

  isAccessTokenInvalido() {
    const token = localStorage.getItem('token');
    
    return !token || this.jwt.isTokenExpired(token);

  }

  limparAccessToken() {
    localStorage.removeItem('token');
    this.jwtPayload = null;
  }

  async temPermissao(permissao: string): Promise<boolean> {
    const usuario = await this.user.getUserInfoByToken().toPromise();
    return usuario.roles.includes(permissao) ? true : false;
  }

  async temQualquerPermissao(roles: string[]): Promise<boolean> {
    for (const role of roles) {
      if (await this.temPermissao(role)) {        
        return true;
      }
    }

    return false;
  }


  private carregarToken(){
    const token = localStorage.getItem('token');

    if(token){
      this.armazenarToken(token);
    }
  }
}
